import Vue from 'vue'
import VueRouter from 'vue-router'
import Maintenance from '../views/Maintenance'
import Home from '../views/home/Index'
import SignUp from '../views/auth/SignUp'
import MyFavorites from '../views/user/MyFavorites'
import Favorites from '../views/user/Favorites'
import Contact from '../views/Contact'
import PrivacyPolicies from '../views/PrivacyPolicies'
import Profile from '../views/user/Profile'
import MyData from '../views/user/MyData'
import Events from '../views/events/Index'
import ShowEvent from '../views/events/Show'
import Checkout from '../views/shopping_cart/Checkout'
import ThankYou from '../views/shopping_cart/ThankYou'
import PaypalConfirm from '../views/shopping_cart/PaypalConfirm'
import PendingOxxo from '../views/shopping_cart/PendingOxxo'
import TermConditions from '../views/TermConditions'
import Minisite from '../views/minisites/Index'
import { AdminRouter } from './adminRouter'
import { LandingRouter, CHUSPIC_LAYOUT_WEB, LANDING_NAME_ROUTER } from './landingRouter';
import { ADMIN_LAYOUT } from './adminRouter';
import { AsdeporteRouter } from './asdeporteRouter'

Vue.use(VueRouter);

const MASTER_TENANT_NAME = 'public';

const routes = [
    {
        path: '/maintenance',
        name: 'Maintenance',
        component: Maintenance,
        meta: {
            layout: "MaintenanceLayout"
        }
    },
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/auth/sign-up',
        name: 'SignUp',
        component: SignUp
    },
    {
        path: '/events',
        name: 'Events',
        component: Events
    },
    {
        path: '/my-data',
        name: 'MyData',
        component: MyData
    },
    {
        path: '/profile',
        name: 'Profile',
        component: Profile
    },
    {
        path: '/events/:id',
        name: 'ShowEvent',
        component: ShowEvent
    },
    {
        path: '/events/:id/album/:album_id',
        name: 'ShowEventAlbum',
        component: ShowEvent
    },
    {
        path: '/minisites/:organizator',
        name: 'Ministite',
        component: Minisite
    },
    {
        path: '/contact',
        name: 'Contact',
        component: Contact
    },
    {
        path: '/privacy-policies',
        name: 'PrivacyPolicies',
        component: PrivacyPolicies
    },
    {
        path: '/terms-conditions',
        name: 'TermsConditions',
        component: TermConditions
    },
    {
        path: '/checkout',
        name: 'Checkout',
        component: Checkout,
        meta: {layout: 'ChuspicLayout'}
    },
    {
        path: '/checkout/thank-you',
        name: 'Checkout.ThankYou',
        component: ThankYou
    },
    {
        path: '/checkout/paypal-confirmation',
        name: 'Checkout.PaypalConfirm',
        component: PaypalConfirm
    },
    {
        path: '/checkout/pending-oxxo',
        name: 'Checkout.PendingOxxo',
        component: PendingOxxo
    },
    {
        path: '/term-conditions',
        name: 'TermConditions',
        component: TermConditions
    },
    {
        path: '/my-favorites',
        name: 'MyFavorites',
        component: MyFavorites
    },
    {
        path: '/users/:id/favorites',
        name: 'UserFavorites',
        component: Favorites
    },
    ...AsdeporteRouter,
    ...AdminRouter,
    ...LandingRouter
]

const router = new VueRouter({
    mode: "history",
    routes
});

router.beforeEach((to, from, next) => {
    const tenantName = document.querySelector('body').dataset.tenantName;

    if(tenantName == MASTER_TENANT_NAME && to.meta.layout != CHUSPIC_LAYOUT_WEB && to.meta.layout != ADMIN_LAYOUT) {
      router.replace({ name: LANDING_NAME_ROUTER });
      return;
    }
    window.scrollTo(0, 0);
    next();
});

export default router;